export interface MarketSession {
  name: string;
  flag: string;
  isOpen: boolean;
  countdown: string;
  activePairs: string[];
  openHourUTC: number;
  closeHourUTC: number;
}

export function getCurrentMarketSessions(): MarketSession[] {
  const now = new Date();
  const utcHour = now.getUTCHours();
  const utcMin = now.getUTCMinutes();
  const utcDay = now.getUTCDay(); // 0=Sun

  // Forex closed: Saturday 21:00 UTC → Sunday 21:00 UTC
  const isWeekendClosed =
    (utcDay === 6 && utcHour >= 21) ||
    (utcDay === 0 && utcHour < 21);

  const sessions = [
    {
      name: 'Sydney',
      flag: '🇦🇺',
      openHourUTC: 21,
      closeHourUTC: 6,
      activePairs: ['AUD/USD', 'NZD/USD'],
    },
    {
      name: 'Tokyo',
      flag: '🇯🇵',
      openHourUTC: 0,
      closeHourUTC: 9,
      activePairs: ['USD/JPY'],
    },
    {
      name: 'London',
      flag: '🇬🇧',
      openHourUTC: 7,
      closeHourUTC: 16,
      activePairs: ['EUR/USD', 'GBP/USD', 'EUR/GBP'],
    },
    {
      name: 'New York',
      flag: '🇺🇸',
      openHourUTC: 12,
      closeHourUTC: 21,
      activePairs: ['EUR/USD', 'GBP/USD', 'USD/JPY', 'USD/CHF', 'USD/CAD'],
    },
  ];

  return sessions.map((s) => {
    const crossesMidnight = s.openHourUTC > s.closeHourUTC;
    let isOpen: boolean;

    if (isWeekendClosed) {
      isOpen = false;
    } else if (crossesMidnight) {
      isOpen = utcHour >= s.openHourUTC || utcHour < s.closeHourUTC;
    } else {
      isOpen = utcHour >= s.openHourUTC && utcHour < s.closeHourUTC;
    }

    let countdown: string;
    if (isWeekendClosed) {
      // Time until Sunday 21:00 UTC
      const hoursToSunday21 =
        utcDay === 6
          ? 24 - utcHour + 21
          : 21 - utcHour;
      countdown = `Opens in ${Math.max(0, hoursToSunday21)}h`;
    } else if (isOpen) {
      const hoursLeft = crossesMidnight
        ? utcHour >= s.openHourUTC
          ? 24 - utcHour + s.closeHourUTC
          : s.closeHourUTC - utcHour
        : s.closeHourUTC - utcHour;
      const minsLeft = 60 - utcMin;
      countdown = `Closes in ${Math.max(0, hoursLeft - 1)}h ${minsLeft}m`;
    } else {
      let hoursToOpen: number;
      if (crossesMidnight) {
        hoursToOpen = s.openHourUTC - utcHour;
      } else {
        hoursToOpen =
          utcHour < s.openHourUTC
            ? s.openHourUTC - utcHour
            : 24 - utcHour + s.openHourUTC;
      }
      const minsToOpen = 60 - utcMin;
      countdown = `Opens in ${Math.max(0, hoursToOpen - 1)}h ${minsToOpen}m`;
    }

    return {
      name: s.name,
      flag: s.flag,
      isOpen,
      countdown,
      activePairs: s.activePairs,
      openHourUTC: s.openHourUTC,
      closeHourUTC: s.closeHourUTC,
    };
  });
}
